import { render, staticRenderFns } from "./DispatchPairColumns.vue?vue&type=template&id=a15ffd0c&name=dispatch-pair-columns&"
import script from "./DispatchPairColumns.vue?vue&type=script&lang=js&"
export * from "./DispatchPairColumns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports